import checkpoint from '@/commons/constants/checkpoint';
import checkpointResource from '@/commons/resources/checkpoint';
import { APPS } from '@/commons/constants/apps';
import Layout from './Layout';
import InfractionsPage from './infractions/pages/InfractionsPage.vue';
import InfractionDetailsPage from './infractions/pages/InfractionDetailsPage.vue';
import InfractionContestationsTermsOfUsePage from './infractions/pages/InfractionContestationsTermsOfUsePage.vue';
import loggedUser, { permissions } from '@/commons/resources/loggedUser';

export default {
  path: '/contestacoes',
  component: Layout,
  name: 'Contestações',
  redirect: {
    name: 'InfractionsPage'
  },
  beforeEnter: () => {
    checkpointResource.create(checkpoint.INFRACTION_CONTESTATION_PAGE_VIEWED);
  },
  children: [
    {
      path: 'infracoes/termos-de-uso',
      component: InfractionContestationsTermsOfUsePage,
      name: 'InfractionContestationsTermsOfUsePage',
      meta: {
        async beforeEnter() {
          const { exists: alreadyAccepted } = await checkpointResource.existsInCompany(
            checkpoint.INFRACTION_CONTESTATION_TERMS_OF_USE_V2
          );

          if (alreadyAccepted) {
            return { name: 'InfractionsPage' };
          }
        }
      }
    },
    {
      path: 'infracoes',
      component: InfractionsPage,
      name: 'InfractionsPage',
      meta: {
        beforeEnter: [termsOfUseGuard]
      }
    },
    {
      path: 'infracoes/:id',
      component: InfractionDetailsPage,
      name: 'InfractionDetailsPage',
      meta: {
        beforeEnter: [termsOfUseGuard]
      }
    }
  ].map(route => ({
    ...route,
    meta: {
      ...route.meta,
      authAs: APPS.PAYMENTS.key,
      isAllowed() {
        return loggedUser.hasPermission(permissions.OperationManageInfractions);
      }
    }
  }))
};

async function termsOfUseGuard() {
  const { exists: alreadyAccepted } = await checkpointResource.existsInCompany(
    checkpoint.INFRACTION_CONTESTATION_TERMS_OF_USE_V2
  );

  if (!alreadyAccepted) {
    return { name: 'InfractionContestationsTermsOfUsePage' };
  }
}
